var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37895 7.28113C5.58986 7.27987 6.21669 7.22341 6.4822 8.11951C6.66105 8.72314 6.94595 9.7119 7.3369 11.0858H7.49611C7.91537 9.63734 8.20338 8.64857 8.36014 8.11951C8.62842 7.21408 9.29911 7.28115 9.56739 7.28115L11.6372 7.28115V13.7198H9.52759V9.92539H9.38612L8.21012 13.7198H6.62289L5.44689 9.92258H5.30542V13.7198H3.1958V7.28115L5.37895 7.28113ZM14.6666 7.28115V11.0784H14.8349L16.2654 7.95594C16.5431 7.33457 17.1349 7.28115 17.1349 7.28115H19.1764V13.7198H17.0227V9.92258H16.8544L15.452 13.045C15.1743 13.6636 14.5544 13.7198 14.5544 13.7198H12.5129V7.28115H14.6666ZM26.6205 10.3408C26.32 11.1921 25.3766 11.8018 24.3321 11.8018H22.0736V13.7198H20.0255V10.3408H26.6205Z",
    fill: "#0F754E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.431 7.28119H19.9182C20.0256 8.71465 21.2601 9.94179 22.538 9.94179H26.7628C27.0066 8.75041 26.1673 7.28119 24.431 7.28119Z",
    fill: "url(#paint0_linear_225_1795)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_1795",
    x1: 26.8043,
    y1: 8.95482,
    x2: 19.9182,
    y2: 8.95482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.caa32f3d.svg";
export { ForwardRef as ReactComponent };